import { ReactElement } from 'react'
import Layout from '../../components/layout'
import AreaList from '../../components/Area'

const AreaPage = (): ReactElement => {
  return (
    <Layout >
      <AreaList />
    </Layout>
  )
}
export default AreaPage
